import { fetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  IContentLibraryIndirectTaxTaxTypesParams,
  IContentLibraryResponse,
} from './types';

// Hook to fetch indirect tax types from Content Library
// Returns tax types with frequencies in standardized format for Form Builder
export function useContentLibraryIndirectTaxTaxTypes(
  params: IContentLibraryIndirectTaxTaxTypesParams | null,
  token?: string
) {
  const cacheKey = params
    ? `content-library/indirect-tax-tax-types:${params.corporationId}:${params.jurisdictionIds.sort().join(',')}`
    : null;

  const { data, mutate, error, isLoading } = useSWR<IContentLibraryResponse>(
    cacheKey,
    async () => {
      if (!params) {
        throw new Error('Params required');
      }
      const response = await fetcher(
        'content-library/indirect-tax-tax-types',
        { method: 'POST', body: params },
        token
      );
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || 'Failed to fetch tax types from content library'
        );
      }
      return response.json();
    }
  );

  return {
    data,
    mutate,
    error,
    isLoading,
  };
}
